import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js"

// Keeps a fixed-layout table's equal-width columns from ever clipping values:
// measures the widest value cell (in a one-frame auto-layout pass with header
// labels out of flow) and pins the table's min-width to widest x columns.
// Above that width the columns are an equal share of the container; below it
// the scrolling container takes over. Truncated header labels get an instant
// tippy tooltip with the full name.
export default class extends Controller {
  connect() {
    this.pinMinWidth()
    this.attachTooltips()
    // cell widths change when web fonts finish loading, so measure again
    document.fonts?.ready?.then(() => this.element.isConnected && this.pinMinWidth())
  }

  disconnect() {
    this.tooltips?.forEach((tooltip) => tooltip.destroy())
  }

  pinMinWidth() {
    this.element.style.minWidth = ""
    this.element.classList.add("table-squeeze--measuring")
    const cells = [...this.element.querySelectorAll("tbody td:not([colspan]), tfoot td:not([colspan])")]
    const widest = Math.max(0, ...cells.map((cell) => cell.offsetWidth))
    const columns = this.element.querySelectorAll("thead th").length
    this.element.classList.remove("table-squeeze--measuring")

    if (widest > 0 && columns > 0) this.element.style.minWidth = `${widest * columns}px`
  }

  attachTooltips() {
    this.tooltips = tippy(this.element.querySelectorAll("thead [title]"), {
      theme: "light",
      delay: 0,
      duration: 0,
      content: (reference) => reference.getAttribute("title"),
      // swap the native title for the tippy so the browser tooltip doesn't double up
      onCreate: (instance) => instance.reference.removeAttribute("title")
    })
  }
}
